/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {startLoadding, stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {fetchAsyncUserDetails} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL

// Team Member interface for type safety
interface TeamMember {
  _id: string
  name: string
  email: string
  avatar?: string
  assignedContacts?: string[]
}

const initialState = {
  InboxMsg: [],
  singleChat: [],
  replyData: {
    receiver: '',
  },
  sidebarRedDot: {},
  // New state for enhanced inbox functionality
  selectedConversations: [] as string[],
  bulkActionMode: false,
  assigneeFilter: null as string | null,
  teamMembers: [] as TeamMember[],
}

const RouteUrl = {
  GetAllData: 'gateway/inbox-quick-sms',
  GetSingleChat: 'gateway',
  EditData: '',
  CreateData: 'gateway',
}
const thunkName = {
  GetAllData: 'gateway-GetAllInbox',
  GetData: '',
  EditData: '',
  CreateData: 'gateway-sendMsg',
  GetSingleChat: 'gateeay-singleChat',
}

export const sendSMSInbox: any = createAsyncThunk(
  'quickSms/sendSMSInbox',
  async (data: any, thunkApi: any) => {
    const response = await axios.post(`${API_URL}gateway`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    let num = data?.contacts?.[0]

    thunkApi.dispatch(
      GetSingleChat({
        page: 1,
        sortField: 'createdAt',
        sortOrder: 'descend',
        receiver: num,
        limit: 20,
        firstTime: true,
      })
    )
    thunkApi.dispatch(fetchAsyncUserDetails())
    return response.data
  }
)

export const sendRMSChat: any = createAsyncThunk(
  'quickSms/sendRMSChat',
  async (data: any, thunkApi: any) => {
    const response = await axios.post(`${API_URL}chat`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    let num = data?.contacts?.[0]

    thunkApi.dispatch(
      GetSingleChat({
        page: 1,
        sortField: 'createdAt',
        sortOrder: 'descend',
        receiver: num,
        limit: 20,
        firstTime: true,
      })
    )
    thunkApi.dispatch(fetchAsyncUserDetails())
    return response.data
  }
)
export const sendRmsSMSInbox: any = createAsyncThunk(
  'quickSms/sendRmsSMSInbox',
  async (data: any, thunkApi: any) => {
    const response = await axios.post(`${API_URL}gateway`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    let num = data?.contacts?.[0]
    let x = num?.[0].slice(0, 2)

    thunkApi.dispatch(
      GetSingleRmsChat({
        id: data?.id,
      })
    )
    return response.data
  }
)

export const inboxArchiveFlag: any = createAsyncThunk(
  'inbox/archiveFlag',
  async (data: any, thunkApi: any) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.put(
      `${API_URL}gateway/inboxFlagChange?receiver=${data.receiver}`,
      data.data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    // thunkApi.dispatch(GetAllData({sortField: 'createdAt', sortOrder: 'descend', size:  data?.limit}))
    // let num = data?.contacts?.[0]
    // let x = num?.[0].slice(0, 2)

    // thunkApi.dispatch(
    //   GetSingleRmsChat({
    //     id: data?.id,
    //   })
    // )
    return response.data
  }
)

export const GetSingleChat: any = createAsyncThunk(
  thunkName.GetSingleChat,
  async (data, thunkApi) => {
    const {firstTime, ...rest}: any = data
    if (firstTime) thunkApi.dispatch(startLoadding())
    const response = await axios.get(`${API_URL}${RouteUrl.GetSingleChat}`, {
      params: rest,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const GetSingleRmsChat: any = createAsyncThunk(
  'GetSingleRmsChat',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.get(`${API_URL}chat/getSubscriberChatHistory/${data?.id}`, {
      params: {},
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const GetRmsChatList: any = createAsyncThunk('GetRmsChatList', async (data, thunkApi) => {
  thunkApi.dispatch(startLoadding())
  const response = await axios.get(`${API_URL}chat/getSubscriberList`, {
    params: data,
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  thunkApi.dispatch(stopLoading())
  return response.data
})
export const GetAllData: any = createAsyncThunk(
  thunkName.GetAllData,
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    if (!data?.size) {
      data.size = 50
    }

    const response = await axios.get(`${API_URL}${RouteUrl.GetAllData}`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const CreateData: any = createAsyncThunk(
  thunkName.CreateData,
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}${RouteUrl.CreateData}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetAllData())
  }
)
export const UpdateData: any = createAsyncThunk(thunkName.EditData, async (data: any, thunkApi) => {
  thunkApi.dispatch(startLoadding())
  const response = await axios.post(`${API_URL}${RouteUrl.CreateData}/${data?.id}`, data.data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status == true && toast.success(response.data.message)
  }
  thunkApi.dispatch(stopLoading())
  thunkApi.dispatch(GetAllData())
})

export const InboxSmsBadge: any = createAsyncThunk('INBOX_SMS_BADGE', async (data, thunkApi) => {
  const response = await axios.get(`${API_URL}gateway/inbox-sms-badge`, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  thunkApi.dispatch(stopLoading())
  return response.data
})

export const ConversationBadge: any = createAsyncThunk(
  'CONVERSATION_BADGE',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}conversations/badge`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    // Transform response to match legacy format for compatibility
    const unreadCount = response.data?.data?.unreadCount || 0
    return {
      ...response.data,
      data: {
        isUnreadMessage: unreadCount > 0,
        unread: unreadCount,
      },
    }
  }
)

// New async thunks for enhanced inbox functionality

export const fetchTeamMembers: any = createAsyncThunk(
  'inbox/fetchTeamMembers',
  async (data: any, thunkApi) => {
    try {
      const response = await axios.get(`${API_URL}user/getlistofSubAccount`, {
        params: data,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      return response.data
    } catch (error) {
      return thunkApi.rejectWithValue(error)
    }
  }
)

export const assignConversation: any = createAsyncThunk(
  'inbox/assignConversation',
  async (data: {conversationId: string; assigneeId: string}, thunkApi) => {
    try {
      thunkApi.dispatch(startLoadding())
      const response = await axios.post(
        `${API_URL}gateway/inbox/assign`,
        {
          conversationId: data.conversationId,
          assigneeId: data.assigneeId,
        },
        {
          headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
        }
      )
      thunkApi.dispatch(stopLoading())
      if (response.data?.status) {
        toast.success('Conversation assigned successfully')
      }
      return response.data
    } catch (error: any) {
      thunkApi.dispatch(stopLoading())
      toast.error(error?.response?.data?.message || 'Failed to assign conversation')
      return thunkApi.rejectWithValue(error)
    }
  }
)

export const bulkAssignConversations: any = createAsyncThunk(
  'inbox/bulkAssignConversations',
  async (data: {conversationIds: string[]; assigneeId: string}, thunkApi) => {
    try {
      thunkApi.dispatch(startLoadding())
      const response = await axios.post(
        `${API_URL}gateway/inbox/bulk-assign`,
        {
          conversationIds: data.conversationIds,
          assigneeId: data.assigneeId,
        },
        {
          headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
        }
      )
      thunkApi.dispatch(stopLoading())
      if (response.data?.status) {
        toast.success(`${data.conversationIds.length} conversations assigned successfully`)
      }
      return response.data
    } catch (error: any) {
      thunkApi.dispatch(stopLoading())
      toast.error(error?.response?.data?.message || 'Failed to assign conversations')
      return thunkApi.rejectWithValue(error)
    }
  }
)

export const bulkArchiveConversations: any = createAsyncThunk(
  'inbox/bulkArchiveConversations',
  async (data: {conversationIds: string[]}, thunkApi) => {
    try {
      thunkApi.dispatch(startLoadding())
      const response = await axios.post(
        `${API_URL}gateway/inbox/bulk-archive`,
        {
          conversationIds: data.conversationIds,
        },
        {
          headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
        }
      )
      thunkApi.dispatch(stopLoading())
      if (response.data?.status) {
        toast.success(`${data.conversationIds.length} conversations archived successfully`)
      }
      return response.data
    } catch (error: any) {
      thunkApi.dispatch(stopLoading())
      toast.error(error?.response?.data?.message || 'Failed to archive conversations')
      return thunkApi.rejectWithValue(error)
    }
  }
)

export const bulkUnsubscribeConversations: any = createAsyncThunk(
  'inbox/bulkUnsubscribeConversations',
  async (data: {conversationIds: string[]}, thunkApi) => {
    try {
      thunkApi.dispatch(startLoadding())
      const response = await axios.post(
        `${API_URL}gateway/inbox/bulk-unsubscribe`,
        {
          conversationIds: data.conversationIds,
        },
        {
          headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
        }
      )
      thunkApi.dispatch(stopLoading())
      if (response.data?.status) {
        toast.success(`${data.conversationIds.length} conversations unsubscribed successfully`)
      }
      return response.data
    } catch (error: any) {
      thunkApi.dispatch(stopLoading())
      toast.error(error?.response?.data?.message || 'Failed to unsubscribe conversations')
      return thunkApi.rejectWithValue(error)
    }
  }
)

export const bulkAddTagsToConversations: any = createAsyncThunk(
  'inbox/bulkAddTagsToConversations',
  async (data: {conversationIds: string[]; tagIds: string[]}, thunkApi) => {
    try {
      thunkApi.dispatch(startLoadding())
      const response = await axios.post(
        `${API_URL}gateway/inbox/bulk-add-tags`,
        {
          conversationIds: data.conversationIds,
          tagIds: data.tagIds,
        },
        {
          headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
        }
      )
      thunkApi.dispatch(stopLoading())
      if (response.data?.status) {
        toast.success(
          `${data.tagIds.length} tag${data.tagIds.length > 1 ? 's' : ''} added to ${
            data.conversationIds.length
          } conversation${data.conversationIds.length > 1 ? 's' : ''} successfully`
        )
      }
      return response.data
    } catch (error: any) {
      thunkApi.dispatch(stopLoading())
      toast.error(error?.response?.data?.message || 'Failed to add tags to conversations')
      return thunkApi.rejectWithValue(error)
    }
  }
)

export const bulkMarkAsReadConversations: any = createAsyncThunk(
  'inbox/bulkMarkAsReadConversations',
  async (data: {conversationIds: string[]}, thunkApi) => {
    try {
      thunkApi.dispatch(startLoadding())
      const response = await axios.post(
        `${API_URL}gateway/inbox/bulk-mark-as-read`,
        {
          conversationIds: data.conversationIds,
        },
        {
          headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
        }
      )
      thunkApi.dispatch(stopLoading())
      if (response.data?.status) {
        toast.success(
          `${data.conversationIds.length} conversation${
            data.conversationIds.length > 1 ? 's' : ''
          } marked as read successfully`
        )
      }
      return response.data
    } catch (error: any) {
      thunkApi.dispatch(stopLoading())
      toast.error(error?.response?.data?.message || 'Failed to mark conversations as read')
      return thunkApi.rejectWithValue(error)
    }
  }
)

export const bulkCloseAsReadConversations: any = createAsyncThunk(
  'inbox/bulkCloseAsReadConversations',
  async (data: {conversationIds: string[]}, thunkApi) => {
    try {
      thunkApi.dispatch(startLoadding())
      const response = await axios.post(
        `${API_URL}gateway/inbox/bulk-close-as-read`,
        {
          conversationIds: data.conversationIds,
        },
        {
          headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
        }
      )
      thunkApi.dispatch(stopLoading())
      if (response.data?.status) {
        toast.success(
          `${data.conversationIds.length} conversation${
            data.conversationIds.length > 1 ? 's' : ''
          } closed as read successfully`
        )
      }
      return response.data
    } catch (error: any) {
      thunkApi.dispatch(stopLoading())
      toast.error(error?.response?.data?.message || 'Failed to close conversations as read')
      return thunkApi.rejectWithValue(error)
    }
  }
)

export const bulkFlagConversations: any = createAsyncThunk(
  'inbox/bulkFlagConversations',
  async (data: {conversationIds: string[]; flagStatus?: boolean}, thunkApi) => {
    try {
      thunkApi.dispatch(startLoadding())
      const response = await axios.post(
        `${API_URL}gateway/inbox/bulk-flag`,
        {
          conversationIds: data.conversationIds,
          isFlagged: data.flagStatus !== undefined ? data.flagStatus : true,
        },
        {
          headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
        }
      )
      thunkApi.dispatch(stopLoading())
      if (response.data?.status) {
        const actionText = data.flagStatus !== false ? 'flagged' : 'unflagged'
        toast.success(
          `${data.conversationIds.length} conversation${
            data.conversationIds.length > 1 ? 's' : ''
          } ${actionText} successfully`
        )
      }
      return response.data
    } catch (error: any) {
      thunkApi.dispatch(stopLoading())
      toast.error(error?.response?.data?.message || 'Failed to flag conversations')
      return thunkApi.rejectWithValue(error)
    }
  }
)

export const bulkDeleteConversations: any = createAsyncThunk(
  'inbox/bulkDeleteConversations',
  async (data: {conversationIds: string[]}, thunkApi) => {
    try {
      thunkApi.dispatch(startLoadding())
      const response = await axios.delete(`${API_URL}gateway/inbox/bulk-delete`, {
        data: {
          conversationIds: data.conversationIds,
        },
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      thunkApi.dispatch(stopLoading())
      if (response.data?.status) {
        toast.success(
          `${data.conversationIds.length} conversation${
            data.conversationIds.length > 1 ? 's' : ''
          } deleted successfully`
        )
      }
      return response.data
    } catch (error: any) {
      thunkApi.dispatch(stopLoading())
      toast.error(error?.response?.data?.message || 'Failed to delete conversations')
      return thunkApi.rejectWithValue(error)
    }
  }
)

export const getFilteredInboxData: any = createAsyncThunk(
  'inbox/getFilteredInboxData',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    if (!data?.size) {
      data.size = 50
    }

    // Add assignee filter to the request if present
    const params = {
      ...data,
      ...(data.assigneeFilter && {assigneeId: data.assigneeFilter}),
    }

    const response = await axios.get(`${API_URL}${RouteUrl.GetAllData}`, {
      params,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

const InboxData = createSlice({
  name: 'InboxData',
  initialState,
  reducers: {
    ReplyInboxData: (state, {payload}) => {
      return {...state, replyData: payload}
    },
    // New action creators for bulk selection and filtering
    toggleConversationSelection: (state, {payload}: {payload: string}) => {
      // Ensure selectedConversations is always an array
      if (!state.selectedConversations) {
        state.selectedConversations = []
      }
      const index = state.selectedConversations.indexOf(payload)
      if (index > -1) {
        state.selectedConversations.splice(index, 1)
      } else {
        state.selectedConversations.push(payload)
      }
    },
    selectAllConversations: (state, {payload}: {payload: string[]}) => {
      state.selectedConversations = payload
    },
    clearConversationSelection: (state) => {
      state.selectedConversations = []
    },
    setBulkActionMode: (state, {payload}: {payload: boolean}) => {
      state.bulkActionMode = payload
      if (!payload) {
        state.selectedConversations = []
      }
    },
    setAssigneeFilter: (state, {payload}: {payload: string | null}) => {
      state.assigneeFilter = payload
    },
    clearAssigneeFilter: (state) => {
      state.assigneeFilter = null
    },
    addConversationToSelection: (state, {payload}: {payload: string}) => {
      // Ensure selectedConversations is always an array
      if (!state.selectedConversations) {
        state.selectedConversations = []
      }
      if (!state.selectedConversations.includes(payload)) {
        state.selectedConversations.push(payload)
      }
    },
    removeConversationFromSelection: (state, {payload}: {payload: string}) => {
      // Ensure selectedConversations is always an array
      if (!state.selectedConversations) {
        state.selectedConversations = []
      }
      const index = state.selectedConversations.indexOf(payload)
      if (index > -1) {
        state.selectedConversations.splice(index, 1)
      }
    },

    // Remove the conversation from InboxMsg.data.items
    updateConversationArchive: (state: any, {payload}: {payload: {conversationId: string}}) => {
      if (state.InboxMsg && state.InboxMsg.data && Array.isArray(state.InboxMsg.data.items)) {
        state.InboxMsg.data.items = state.InboxMsg.data.items.filter(
          (item: any) => !(item.contacts && item.contacts._id === payload.conversationId)
        )
        const after = state.InboxMsg.data.items.length
        // Update pagination if exists
        if (state.InboxMsg.data.pagination) {
          state.InboxMsg.data.pagination.total = Math.max(
            0,
            state.InboxMsg.data.pagination.total - 1
          )
          const limit = state.InboxMsg.data.pagination.limit || 50
          state.InboxMsg.data.pagination.totalPages = Math.max(
            1,
            Math.ceil(state.InboxMsg.data.pagination.total / limit)
          )
          // If current page is now empty and not the first, go to previous page
          if (after === 0 && state.InboxMsg.data.pagination.current > 1) {
            state.InboxMsg.data.pagination.current -= 1
          }
          // Update pagingCounter if needed
          state.InboxMsg.data.pagination.pagingCounter =
            (state.InboxMsg.data.pagination.current - 1) * limit + 1
        }
      }
    },

    // Optimistically update Flag for a conversation
    updateConversationFlag: (
      state: any,
      {
        payload,
      }: {
        payload: {
          conversationId: string
          isFlagged: boolean
          isArchived: boolean
          isTicked: boolean
        }
      }
    ) => {
      if (state.InboxMsg && state.InboxMsg.data && Array.isArray(state.InboxMsg.data.items)) {
        const idx = state.InboxMsg.data.items.findIndex(
          (item: any) => item.contacts && item.contacts._id === payload.conversationId
        )
        if (idx !== -1) {
          state.InboxMsg.data.items[idx] = {
            ...state.InboxMsg.data.items[idx],
            contacts: {
              ...state.InboxMsg.data.items[idx].contacts,
              isFlagged: payload.isFlagged,
              isArchived: payload.isArchived,
              isTicked: payload.isTicked,
            },
          }
        }
      }
    },
  },
  extraReducers: (builder) => {
    // Existing reducers
    builder.addCase(GetAllData.fulfilled, (state, action) => {
      return {...state, InboxMsg: action?.payload}
    })
    builder.addCase(GetSingleChat.fulfilled, (state, action) => {
      return {...state, singleChat: action?.payload}
    })
    builder.addCase(GetRmsChatList.fulfilled, (state, action) => {
      return {...state, rmsChats: action?.payload}
    })
    builder.addCase(GetSingleRmsChat.fulfilled, (state, action) => {
      return {...state, rmsSingleChats: action?.payload}
    })
    builder.addCase(InboxSmsBadge.fulfilled, (state, action) => {
      return {...state, sidebarRedDot: action?.payload}
    })
    builder.addCase(ConversationBadge.fulfilled, (state, action) => {
      return {...state, sidebarRedDot: action?.payload}
    })

    // New reducers for enhanced functionality
    builder.addCase(fetchTeamMembers.fulfilled, (state, action) => {
      state.teamMembers = action?.payload?.data || []
    })
    builder.addCase(fetchTeamMembers.rejected, (state, action) => {
      state.teamMembers = []
    })
    builder.addCase(getFilteredInboxData.fulfilled, (state, action) => {
      return {...state, InboxMsg: action?.payload}
    })
    builder.addCase(assignConversation.fulfilled, (state, action) => {
      // Optionally update local state to reflect assignment
      // This could be enhanced to update the specific conversation in the list
    })
    builder.addCase(bulkAssignConversations.fulfilled, (state, action) => {
      // Clear selection after successful bulk assignment
      state.selectedConversations = []
      state.bulkActionMode = false
    })
    builder.addCase(bulkArchiveConversations.fulfilled, (state, action) => {
      // Clear selection after successful bulk archive
      state.selectedConversations = []
      state.bulkActionMode = false
    })
    builder.addCase(bulkUnsubscribeConversations.fulfilled, (state, action) => {
      // Clear selection after successful bulk unsubscribe
      state.selectedConversations = []
      state.bulkActionMode = false
    })
    builder.addCase(bulkAddTagsToConversations.fulfilled, (state, action) => {
      // Clear selection after successful bulk tag addition
      state.selectedConversations = []
      state.bulkActionMode = false
    })
    builder.addCase(bulkMarkAsReadConversations.fulfilled, (state, action) => {
      // Clear selection after successful bulk mark as read
      state.selectedConversations = []
      state.bulkActionMode = false
    })
    builder.addCase(bulkCloseAsReadConversations.fulfilled, (state, action) => {
      // Clear selection after successful bulk close as read
      state.selectedConversations = []
      state.bulkActionMode = false
    })
    builder.addCase(bulkFlagConversations.fulfilled, (state, action) => {
      // Clear selection after successful bulk flag
      state.selectedConversations = []
      state.bulkActionMode = false
    })
    builder.addCase(bulkDeleteConversations.fulfilled, (state, action) => {
      // Clear selection after successful bulk delete
      state.selectedConversations = []
      state.bulkActionMode = false
    })
  },
})

// Existing selectors
export const getSingleChat = (state: any) => state?.InboxData?.singleChat?.data
export const getSingleRmsChat = (state: any) => state?.InboxData?.rmsSingleChats?.data
export const getRmsChat = (state: any) => state?.InboxData?.rmsChats?.data
export const getAllChat = (state: any) => state?.InboxData?.InboxMsg?.data
export const getReplyInboxData = (state: any) => state?.InboxData?.replyData
export const getSidebarRedDotData = (state: any) => state?.InboxData?.sidebarRedDot?.data

// New selectors for enhanced inbox functionality
export const getSelectedConversations = (state: any) =>
  state?.InboxData?.selectedConversations || []
export const getBulkActionMode = (state: any) => state?.InboxData?.bulkActionMode || false
export const getAssigneeFilter = (state: any) => state?.InboxData?.assigneeFilter
export const getTeamMembers = (state: any) => state?.InboxData?.teamMembers || []
export const getSelectedConversationsCount = (state: any) =>
  state?.InboxData?.selectedConversations?.length || 0
export const isConversationSelected = (conversationId: string) => (state: any) =>
  state?.InboxData?.selectedConversations?.includes(conversationId) || false
export const hasSelectedConversations = (state: any) =>
  (state?.InboxData?.selectedConversations?.length || 0) > 0

// Export all action creators
export const {
  ReplyInboxData,
  toggleConversationSelection,
  selectAllConversations,
  clearConversationSelection,
  setBulkActionMode,
  setAssigneeFilter,
  clearAssigneeFilter,
  addConversationToSelection,
  removeConversationFromSelection,
} = InboxData.actions

export default InboxData.reducer
